// removed by extract-text-webpack-plugin
module.exports = {"rsvp-accepted-container":"rsvp-buttons__rsvp-accepted-container__1GaIC","rsvp-declined-container":"rsvp-buttons__rsvp-declined-container__RkMK9","rsvp-message":"rsvp-buttons__rsvp-message__365m7","buttons-container":"rsvp-buttons__buttons-container__3o2Yr","button":"rsvp-buttons__button__2unFP","button-disable":"rsvp-buttons__button-disable__2upib"};


//////////////////
// WEBPACK FOOTER
// ./src/components/details/rsvp-buttons.scss
// module id = 1314
// module chunks = 1